import { render, staticRenderFns } from "./MotivoReagendamentoModal.vue?vue&type=template&id=847985f8"
import script from "./MotivoReagendamentoModal.vue?vue&type=script&lang=js"
export * from "./MotivoReagendamentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports